import React, { useState } from "react"
import BusinessBootcampDuoVideo from "./BusinessBootcampDuoVideo"
import Loader from "../../../components/ui/loader"
import Recaptcha from "../../../components/auth/register-form/Recaptcha"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Link } from "react-router-dom"
import { SvgZoeeLogoColored } from "../../../components/icons"

const BusinessBootcampRegistrationPage = () => {
  const [name, setName] = useState("")
  const [nameError, setNameError] = useState("")
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState("")
  const [isNotRobot, setIsNotRobot] = useState(false)
  const [loading, setLoading] = useState(false)

  const validateEmail = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setName(value)
    setNameError(value.trim() === "" ? "Name is required" : "")
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setEmail(value)
    if (value === "") setEmailError("Email is required")
    else if (!validateEmail(value)) setEmailError("Enter a valid email address")
    else setEmailError("")
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (
      !isNotRobot ||
      emailError ||
      nameError ||
      !validateEmail(email) ||
      name.trim() === ""
    )
      return

    setLoading(true)
    try {
      localStorage.setItem("name", name)
      localStorage.setItem("email", email)
      window.location.href = "https://www.paypal.com/ncp/payment/JA35NQ4XWR9DQ"
    } catch (err) {
      console.error("Error saving data:", err)
    } finally {
      setLoading(false)
    }
  }

  const isButtonDisabled =
    !isNotRobot ||
    emailError !== "" ||
    nameError !== "" ||
    name.trim() === "" ||
    email.trim() === ""

  return (
    <div className="h-[100%] md:h-[100vh] flex flex-col md:flex-row">
      {/* Left Section */}
      <section className="bg-[#F2F5F7] md:w-[50%] flex md:justify-end md:items-top md:pr-[35px]  justify-center items-center ">
        <div className="md:w-[550px] h-fit md:p-10 px-4 py-10 flex flex-col gap-6">
          <Link to="/5daybusinessbootcamp">
            <SvgZoeeLogoColored className="w-48 h-28 -mb-6" />
          </Link>
          <div className="flex-1 p-4 flex border-4 border-blurple bg-blurple">
            <BusinessBootcampDuoVideo />
          </div>
          <p className="text-2xl">
            Gain exclusive access to the From Purpose to Profit: The 5-Day
            Business Bootcamp for Coaches for only{" "}
            <span
              className="relative inline-block text-blurple font-bold text-xl"
              style={{ display: "inline-block", position: "relative" }}
            >
              <span
                style={{
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  width: "100%",
                  height: "5px",
                  backgroundColor: "red",
                  transform: "rotate(-20deg) translateY(-50%)",
                  transformOrigin: "center",
                }}
              ></span>
              $695
            </span> {""}
            <span className="text-blurple font-bold text-xl">$556</span> (value
            $1500).
          </p>

          <p className="-mb-4">
            <span className="font-bold">Program Dates:</span> January 13–18,
            2026
          </p>
          {/* <p className="-mb-4">
            <span className="font-bold">Time:</span> 12 PM EST - 1:30 PM EST (90
            minutes each day)
          </p> */}
          <p>
            <span className="font-bold">Format:</span> Live virtual training
          </p>
        </div>
      </section>

      {/* Right Section */}
      <section className="bg-[#FCFCFC] md:w-[50%] flex justify-center md:justify-start items-center md:pl-[35px]">
        <div className="md:w-[550px] h-fit md:p-10 px-4 py-10 flex flex-col gap-6">
          <div className="flex flex-col gap-2 mb-6">
            <h1 className="font-bold text-[32px]">Get Started</h1>
          </div>

          <form
            className="flex flex-col gap-6 w-full h-fit mb-4"
            onSubmit={handleSubmit}
          >
            <Input
              label="Full Name"
              placeholder="Enter your full name"
              value={name}
              error={nameError}
              onChange={handleNameChange}
            />

            <Input
              label="Email Address"
              placeholder="Enter your email address"
              value={email}
              error={emailError}
              onChange={handleEmailChange}
            />

            <Recaptcha setIsNotRobot={setIsNotRobot} />

            <Button type="submit" size="lg" disabled={isButtonDisabled}>
              {loading ? <Loader /> : "Continue"}
            </Button>
          </form>

          <p className="text-[#7D878F] text-sm">
            By continuing, you agree to Zoee’s{" "}
            <Link
              to="/terms-and-conditions"
              target="_blank"
              className="text-[#000]"
            >
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" target="_blank" className="text-[#000]">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </section>
    </div>
  )
}

export default BusinessBootcampRegistrationPage
